import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ResidenceSection } from '../ResidenceSection';
import {
  Infrastructure,
  InfrastructureBlockDescription,
  InfrastructureDescription,
  InfrastructureDescriptionWrapper,
  InfrastructureImage,
  InfrastructuresContainer,
  infrastructureSectionStyles,
  InfrastructureTitle
} from './styled';
import { ResidenceInfrastructure } from '../../../../graphql/graphql';
import Icon from '../../../Icon';
import DistanceIcon from '../../../../public/static/images/residences/distance.svg';

interface InfrastructuresSectionProps {
  infrastructures: ResidenceInfrastructure[];
}

export const InfrastructureSection: React.FC<InfrastructuresSectionProps> =
  memo(({ infrastructures }) => {
    const { t } = useTranslation();

    return (
      <ResidenceSection
        styles={infrastructureSectionStyles}
        title={t('residences.infrastructure')}
      >
        <InfrastructureBlockDescription tag="body_2">
          {t('residences.infrastructure_description')}
        </InfrastructureBlockDescription>

        <InfrastructuresContainer data-cy="residence-infrastructures">
          {infrastructures.map((infrastructure, index) => {
            if (!infrastructure.infrastructure) return null;

            const infrastructureImage =
              infrastructure.infrastructure.iconUrl ||
              '/static/images/residences/infrastructure-placeholder.png';

            return (
              <Infrastructure key={index} data-cy="residence-infrastructure">
                <InfrastructureImage
                  width={120}
                  height={120}
                  src={infrastructureImage}
                  alt={infrastructure.infrastructure.name}
                />
                <InfrastructureTitle
                  tag="title_4_new"
                  data-cy="residence-infrastructure-title"
                >
                  {infrastructure.infrastructure.name}
                </InfrastructureTitle>
                {infrastructure.distance > 0 && (
                  <InfrastructureDescriptionWrapper>
                    <Icon
                      indent={false}
                      width={10}
                      height={20}
                      IconComponent={DistanceIcon}
                    />
                    <InfrastructureDescription
                      tag="body_2"
                      data-cy="residence-infrastructure-distance"
                    >
                      {t('residences.minutes', {
                        minutes: infrastructure.distance
                      })}
                    </InfrastructureDescription>
                  </InfrastructureDescriptionWrapper>
                )}
              </Infrastructure>
            );
          })}
        </InfrastructuresContainer>
      </ResidenceSection>
    );
  });

InfrastructureSection.displayName = `InfrastructureSection`;
